import { apiClient, Auth } from '@/shared/api'

// import { HOST_CONTRACT_CASE } from '../mock/get-host-contract/case'
import { THostContractDetail } from '../model/schema'

export const getHostContract = async ({
  contractId,
}: {
  contractId: number
}) => {
  const response = await apiClient.get<THostContractDetail>({
    endpoint: `/host/contracts/${contractId}`,
    auth: Auth.REQUIRED,
    // queryParams: {
    //   case: HOST_CONTRACT_CASE.APPROVE_READY,
    // },
    // option: {
    //   useMock: true,
    // },
  })

  return response
}
